import styles from './tooltip.module.css'

import { TooltipOrientationEnum } from './tooltip.type'

export const orientations: Record<TooltipOrientationEnum, string> = {
  left: styles['portal-orientation-left'],
  right: styles['portal-orientation-right'],
  bottom: styles['portal-orientation-bottom'],
  top: styles['portal-orientation-top'],
}

export const generatePortalClasses = (
  orientation: keyof typeof TooltipOrientationEnum,
  className?: string,
) => {
  return `${styles['portal-orientation-core']} ${orientations[orientation]} ${
    className || ''
  }`
}
